import { lazy, useEffect, useState } from "react"
import Spinner from "../../components/Spinner"
import Error from "../../components/Status/Error"
import jwtDecode from "jwt-decode"

const AdminAlerts = lazy(() => import("../operations/alerts/Alerts"))
const TutorAlerts = lazy(() => import("../TutorPortal/Alerts/Alerts"))
const ParentsAlerts = lazy(() => import("../ParentPortal/Alerts/Alerts"))
const SchoolAlerts = lazy(() => import("../SchoolPortal/Alerts/Alerts"))

export default function RootAlerts() {
  const [role, setRole] = useState("")

  useEffect(() => {
    const role = jwtDecode(localStorage.getItem("token")).role
    setRole(role)
  }, []) // 

  if (!role) return <Spinner type="child" />
  if (role === "Student")
    return <Error error="This page is not available" type="unauthorized" />
  if (role === "Admin") return <AdminAlerts />
  if (role === "Tutor" || role === "Senior Tutor") return <TutorAlerts />
  if (role === "Parent") return <ParentsAlerts />
  if (role === "School Manager") return <SchoolAlerts />
}
